import { render, staticRenderFns } from "./EditOrderPayments.vue?vue&type=template&id=0770ca80"
import script from "./EditOrderPayments.vue?vue&type=script&lang=js"
export * from "./EditOrderPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports